<template>
  <v-card style="width: 100% !important; height: 100% !important">
    <v-toolbar dense flat>
      <v-toolbar-title> {{ title }} </v-toolbar-title>
    </v-toolbar>

    <v-card-text class="justify-center" style="margin-bottom: 1.5rem">
      <h3 class="text-center display-3" style="width: 100%; height: 100%">
        21 °C
      </h3>
    </v-card-text>
    <v-card-text class="justify-center date-bottom text-center">
      <v-divider class="mb-4" />
      <span class="mt-4">{{ humanDate(new Date()) }}</span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SinglePreview",
  props: {
    title: {
      default: "Title",
    },
  },
};
</script>